/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2UserCouple/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2UserCouple({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2UserCouple",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 13,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2UserCouple.Svg"
  data-view-path={viewPath}
 viewBox="0 0 13 14"
 style={{'--as-1-ZUgGer': alignSelf,'--mt-2-ZUgGer': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZUgGer': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZUgGer': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZUgGer': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZUgGer': opacity,'--w-10-ZUgGer': typeof width === 'number' ? `${width}px` : width,'--h-11-ZUgGer': typeof height === 'number' ? `${height}px` : height,'--f-12-ZUgGer': fill,'--a-7-ZUgGer': isAnimated ? animation : "none",'--sd-8-ZUgGer': isAnimated ? strokeDashoffset : 0,'--sd-9-ZUgGer': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2UserCouple.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M.464 2.821a2.321 2.321 0 114.643 0 2.321 2.321 0 01-4.643 0zM10.214.5a2.321 2.321 0 100 4.643 2.321 2.321 0 000-4.643zM8.463 7.332c.356-.665.914-1.26 1.751-1.26.838 0 1.396.595 1.752 1.26.36.674.589 1.543.737 2.372.149.837.223 1.669.26 2.288a22.55 22.55 0 01.036.965v.057l.001.016v.005h-.464H13a.465.465 0 01-.464.465H7.893a.464.464 0 01-.464-.464h.464-.464v-.079l.004-.212c.005-.183.014-.442.033-.752.037-.62.11-1.452.26-2.289.148-.829.376-1.698.737-2.372zM0 6.536c0-.257.208-.465.464-.465h4.643c.257 0 .464.208.464.465h-.464.464v.078l-.004.213c-.005.182-.014.441-.033.752-.037.62-.11 1.452-.26 2.288-.148.83-.376 1.699-.737 2.372-.356.665-.913 1.261-1.751 1.261-.838 0-1.395-.596-1.752-1.26-.36-.674-.589-1.544-.737-2.373a20.165 20.165 0 01-.26-2.288 22.382 22.382 0 01-.036-.965v-.057L0 6.542v-.006h.464H0z"
 style={{'--f-12-ZUgGer': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}